/* CreateAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateQuestionComponent = require("./CreateQuestionComponent");
const TreeUtils = require("../../treeUtilities");
const _ = require("lodash");
class CreateAction {
    constructor(logger, gameEditor, modalUserFeedback, SiteEntity, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._siteEntityDef = SiteEntity;
        this._activeOrgId = userSession.activeOrganization.id;
        this._siteEntity = new SiteEntity(userSession.activeOrganization.id);
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this.run = this.run.bind(this);
    }
    run() {
        return this._siteEntityDef
            .loadSites(this._activeOrgId, {}, {}, {path: 1})
            .then((sites) => {
                this._optionsList = TreeUtils.generateOptions(sites);
                const selectedSiteFromGrid = _.get(this._activeView, "selectedRows", [])[0];
                const selectedSiteFromTree = _.get(this._activeView, "_selectedNode._id");
                const selectedSite = selectedSiteFromGrid
                    ? selectedSiteFromGrid
                    : selectedSiteFromTree;

                return this._modalUserFeedback
                    .displayCustom(
                        new CreateQuestionComponent(this._logger, this._optionsList, selectedSite),
                        {dontHide: true}
                    )
                    .then((result) => {
                        this._modalUserFeedback.displayLoading();
                        return this._createSite(result).catch((err) => {
                            this._logger.warn({error: err}, "CreateAction._createSite() error.");
                            if (err.errorMsg.includes("The Site already exists")) {
                                err.errorMsg =
                                    "This site name or code already exists. " +
                                    "Sites that have the same parent must have unique names. " +
                                    "Site codes must be unique.";
                            }
                            return this._modalUserFeedback.displayError(err);
                        });
                    })
                    .then((result) => {
                        let editorState = {
                            fqn: Registrations.SIE_VIEW_DETAILS,
                            viewState: {createMode: true},
                        };
                        const launchOpts = {
                            id: result.id,
                            title: result.properties.name,
                        };
                        this._modalUserFeedback.hideDisplayed();
                        this._gameEditor.launchDeviceEditor(editorState, launchOpts);
                        if (
                            typeof this._activeView.resetSelection === "function" &&
                            typeof this._activeView.loadAndScrollTo === "function"
                        ) {
                            this._activeView.resetSelection([result.id]);
                            this._activeView.loadAndScrollTo(result.id);
                        }
                        return Promise.resolve();
                    });
            })
            .catch((err) => {
                this._modalUserFeedback.hideDisplayed();
                this._logger.warn(
                    {error: err},
                    "CreateAction.run() - Either error or cancellation"
                );
            });
    }
    _createSite(data) {
        this._siteEntity.setName(data.name);
        this._siteEntity.setCodeName(data.code);
        this._siteEntity.setLocationType("SITE");
        if (data.parentSite) {
            this._siteEntity.setParentSiteRelationship(data.parentSite);
        } else {
            this._siteEntity.setProperty("path", data.name); // to be removed
            // this._siteEntity.clearParentSiteRelationship();
        }
        return this._siteEntity.create();
    }
}
module.exports = CreateAction;

CreateAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Site",
    "$teve.userSession",
    "gameEditor.activeView",
];

CreateAction.$displayDetails = {
    type: "Action",
    name: "CreateAction",
    icon: "siteexplorer.add_site",
    shown: true,
    title: "Add Site",
    order: 3,
};
